.results-table thead th {
  border: none;
  margin: 0;
  background-color: var(--brand-grayscale-200);
}

.results-table thead th,
.results-table tbody td {
  padding: 0.5rem;
  text-align: left;
}

/* `td` included in selector to overtake bootstraps striped table specificity */
td.positive-index-01 {
  background-color: #f7fbf3;
}

td.positive-index-02 {
  background-color: #eef6e7;
}

td.positive-index-03 {
  background-color: #e6f2dc;
}

td.positive-index-04 {
  background-color: #deedd0;
}

td.positive-index-05 {
  background-color: #d5e9c4;
}

td.positive-index-06 {
  background-color: #cde5b8;
}

td.positive-index-07 {
  background-color: #c5e0ac;
}

td.positive-index-08 {
  background-color: #bddac1;
}

td.positive-index-09 {
  background-color: #b4d795;
}

td.positive-index-10 {
  background-color: #acd389;
}
